import { graphql } from '@apollo/client/react/hoc';
import { withRouter } from 'react-router-dom';
import productQuery from './productQuery.graphql';
import component from './component';

export default withRouter(graphql(productQuery, {
  options: ({ match }) => ({ variables: { href: match.params.href } }),
  props: ({ data: { product } }) => ({ product })
})(component));
